import React from 'react';
import FinanceSectionInteractiveWorkspace from './FinanceSectionInteractiveWorkspace';

const FinanceTaxesWorkspace = ({ isDarkMode = false }) => (
  <FinanceSectionInteractiveWorkspace isDarkMode={isDarkMode} sectionKey="taxes" />
);

export default FinanceTaxesWorkspace;
